SupportEmailFormModel = require('../../models/email_form')
SharedWidgetLayoutView = require('../../../../shared/frontend/views/widget_layout_veiw')
SupportUtilsHelper = require('../../helpers/utils')
SupportProgressBarView = require('../progress_bar_view')
Backbone = require 'backbone'
Backbone.$ = $

class SupportV1StepThreeBaseView extends Backbone.View
  className: 'horizontal step-three'

  initialize: ->
    if Groupon.Support.MAXINDEX is 2
      @id = 2
    else
      @id = 3
    @emailFormModel = new SupportEmailFormModel
    @emailFormMainView = @getEmailFormView({
      emailFormModel: @emailFormModel
    })
    @contactChannelView = @configureContactChannelView({
      mainView: this
      emailFormModel: @emailFormModel
    })
    @shouldRenderEmailForm = false

  postRenderhandler: () ->
    if @shouldShowContactChannelView()
      @handleDisplayOfContactChannels()
    else
      Groupon.Support.ContentModel.onInitStepThree()

  handleDisplayOfContactChannels: () ->
    @contactChannelView.handleDisplayOfContactChannels()

  render: () ->
    SharedWidgetLayoutView.hideWidgets()
    if @shouldShowContactChannelView()
      @renderContactChannelView()
    else
      window.showFooterLinks()
      @shouldRenderEmailForm = true
      @emailFormMainView.render()
      @$el.html(@emailFormMainView.$el)
      @renderProgressBar()
      @renderLiveChat()

  renderContactChannelView: ->
    @hideComponents()
    @contactChannelView.render()
    @$el.html @contactChannelView.el
    @renderProgressBar()
    @contactChannelView.renderLiveChat()

  isPhonePreferredChannel: () ->
    @emailFormMainView.isPhonePreferredChannel()

  renderEmailForm: () ->
    propagateEventBeforeReplacingElements( () =>
      @emailClickCallback()
    )

  emailClickCallback: () ->
    @shouldRenderEmailForm = true
    @emailFormMainView.contactByEmail()
    @$el.html(@emailFormMainView.$el)
    @renderProgressBar()
    @postEmailFormRenderCallBack()

  postEmailFormRenderCallBack: ->

  renderPhoneNumberView: ->

  submitFormHandler: ->

  shouldShowContactChannelView:()->

  hideComponents: ->
    SupportUtilsHelper.hideFloatingBoldChat()

  renderProgressBar: ()->
    progressBar = new SupportProgressBarView
    progressBar.render()
    @$el.find('.steps-container').append(progressBar.el)

  renderLiveChat: (params = {})->
    liveChatMode = params.liveChatMode || Groupon.Support.LiveChatModel.getDefaultStepThreeLiveChatMode()
    if liveChatMode?
      if window.evaluate(@shouldRenderEmailForm)
        liveChatType =  Groupon.Support.LiveChatModel.getDefaultLiveChatType()
      Groupon.Support.LiveChatView.setLiveChat(liveChatMode, liveChatType || params.liveChatType)
      Groupon.Support.LiveChatView.renderView(@$el, $.extend(true, @emailFormMainView.getChatParams(), {startFromSameViewState: params.startFromSameViewState}))
      if isStaticLiveChat(liveChatMode)
        SupportUtilsHelper.hideFloatingBoldChat()
      else
        SupportUtilsHelper.showFloatingBoldChat()

  renderChatClickView: () ->

  isFlexibleContactEnabled: () ->
    window.evaluate(window.experiments?.showFlexibleContactChannels)

  isOptimizedContactEnabled: () ->
    window.evaluate(experiments?.showOptimizedContactChannel)

module.exports = SupportV1StepThreeBaseView
